import { Avatar, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allJugadoresAction,
  deleteJugadoresAction,
  setActivoJugadoresAction,
} from '../JugadoresAction';
import { PARAMS_JUGADORES } from '../JugadoresReducer';
import ExpandedJugadoresComponent from './ExpandedJugadores';

const ListadoJugadores = ({
  setOpenModalForm,
  isEdit = true,
  showColumnEquipo = true,
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const torneosStore = Redux.useSelector((state) => state.torneos);
  const jugadoresStore = Redux.useSelector((state) => state.jugadores);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...jugadoresStore.params,
        idEntidad: entidadesStore.activo.id,
        idTorneo: torneosStore.activo?.id,
      };
      dispatch({ type: PARAMS_JUGADORES, payload });

      if (jugadoresStore.all && jugadoresStore.all.length === 0) {
        await allJugadoresAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    jugadoresStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        jugador: {
          foto: el.jugador.perfil.avatar,
          nombre: `${el.jugador.perfil.tipoDni}-${el.jugador.perfil.dni} ${el.jugador.perfil.pnombre} ${el.jugador.perfil.papellido}`,
        },
        equipo: {
          imagen: el.equipo.imagen,
          nombre: el.equipo.nombre,
        },
        estatus: el.estatus.nombre,
      });
    });
    setRows(rowsData);
  }, [jugadoresStore.all]);

  const _handleEditClick = async (id) => {
    if (!isEdit) return;

    const data = jugadoresStore.all.find((el) => el.id === id);
    await setActivoJugadoresAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteJugadoresAction(
      { dispatch, notify },
      jugadoresStore.activo.id,
      jugadoresStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  function getDataStore(id) {
    return jugadoresStore.all.find((el) => el.id === id);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.jugador.name,
      label: CONST.jugador.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
            >
              <Avatar
                alt={value.foto}
                sx={{ width: 50, height: 50, mr: 1 }}
                src={getFilesArchivos(value.foto)}
              />
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.nombre}
              </NameComponent>
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              {/* <BotonComponent
                click={async () => {
                  // await setActivoJuegosAction(
                  //   dispatch,
                  //   getDataStore(tableMeta.rowData[0]),
                  // );
                  // history.push(ROUTES.panelJuegos.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel de jugador"
              /> */}
              {isEdit && (
                <ActionsListWidget
                  id={tableMeta.rowData[0]}
                  onDelete={
                    isEdit
                      ? () => {
                          setActivoJugadoresAction(
                            dispatch,
                            getDataStore(tableMeta.rowData[0]),
                          );
                          setOpenModalDelete(true);
                        }
                      : null
                  }
                  onDownload={() => {
                    window.open(value.url);
                  }}
                />
              )}
            </Stack>
          );
        },
      },
    },
  ];

  if (showColumnEquipo) {
    columns.splice(2, 0, {
      name: CONST.equipo.name,
      label: CONST.equipo.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
            >
              <Avatar
                alt={value.imagen}
                sx={{ width: 50, height: 50, mr: 1 }}
                src={getFilesArchivos(value.imagen)}
              />
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.nombre}
              </NameComponent>
            </Stack>
          );
        },
      },
    });
  }

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = jugadoresStore.all.find((el) => el.id === rowData[0]);
      return <ExpandedJugadoresComponent data={data} rowData={rowData} />;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={jugadoresStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title="Listado"
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {jugadoresStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{jugadoresStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoJugadores;
